import React, { createRef } from "react";
import { connect } from "react-redux";
import language from "../../../../language";
import { Loading } from "../../../Loader";
import { Empty } from "../../../Empty";
import { fetchInventories } from "../../../../utils/queries/inventories/center";
import toastMessage from "../../../../utils/toastMessage";
import moment from "moment-timezone";
import { PrintComponent } from "../../../Print";
import Barcode from "react-barcode";
import { Checkbox } from "../../../Input";
import { Button } from "../../../Button";
import axios from "axios";
import { getStorage } from "../../../../utils/storage";
import BarcodeScannerInput from "../../../Barcode/BarcodeScannerInput";
import rbcLogo from "../../../../assets/rbc-logo.png";
import "./styles.css";
import debounce from "lodash.debounce";
// eslint-disable-next-line no-unused-vars

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
// eslint-disable-next-line no-unused-vars
let countScan = 0;

// eslint-disable-next-line no-unused-vars
// Serology arrives grouped by answer - "HIV:Reactive, HBsAg,HCV:Non
// Reactive" - one group per result. Splitting on ", " gives those groups
// back so the reactive one can be printed apart from the rest.
const serologyGroups = (result) =>
  String(result || "")
    .split(", ")
    .map((g) => g.trim())
    .filter(Boolean);

// Gray zone is not a clean result either, so it travels with the reactive
// ones rather than sitting among the non-reactive.
const isCleanGroup = (group) => {
  const answer = String(group).slice(String(group).lastIndexOf(":") + 1)
    .toUpperCase();

  if (answer.includes("GRAY")) return false;

  return !(answer.includes("REACTIVE") && !answer.includes("NON"));
};

class PrintableLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      donation: {},
      isVerifying: false,
      isFocused: false,
      countScan: 0,
    
    scannedValue: "",
};

    this.scannerInputRef = createRef();
    this.handleScan = debounce(this.handleScan.bind(this), 1000);
  }

  componentDidMount() {
    this.getData(true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.productId !== this.props.productId) {
      this.getData(true);
    }
  }

  getData = async (isLoading) => {
    try {
      this.setState({ isLoading });

      if (!this.props.productId)
        return toastMessage("error", "Product ID is missing");

      const data = await fetchInventories(this.props.defaultLanguage, {
        id: this.props.productId,
      });

      this.setState({ data, isLoading: false });

      if (data.isLabeled) {
        this.props.handleCloseModal();
      }
    } catch (error) {
      this.setState({ isLoading: false });

      toastMessage(error);
    }
  };

  renderInfo = ({
    title,
    description,
    barCode,
    isBlocked,
    type,
    reason,
    isTestResult,
    showValue,
    code,
    isMissingBloodGroup,
    noPrint,
    missingTestNames,
    duResult,
  }) => {
    return (
      <div className="d-flex align-items-center">
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            position: "relative",
            zIndex: 900,
          }}
        >
          <span
            style={{
              fontSize: type === "checkComponent" ? 18 : 14,
              marginRight: 8,
              fontWeight: type === "checkComponent" ? "900" : "300",
            }}
          >
            {title}
          </span>
          {isBlocked && (
            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
              <span className="text-danger">(Blocked)</span>
              {reason && type !== "checkBloodGroup" && (
                <span className="text-danger" style={{ fontSize: 10, fontStyle: "italic" }}>
                  {reason}
                </span>
              )}
            </div>
          )}
          {type === "checkBloodGroup" && (
            <div style={{ position: "relative", zIndex: 900 }}>
              <div
                style={{
                  fontSize: "3rem",
                  marginLeft: ".5rem",
                  fontWeight: 600,
                  marginRight: 8,
                  left: 0,
                  zIndex: 900,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "0",
                }}
              >
                <span
                  className={
                    isMissingBloodGroup || !isTestResult || missingTestNames?.length > 0
                      ? "noPrint"
                      : ""
                  }
                >
                  <div
                    style={{
                      border: barCode?.includes("+") ? "1px solid black" : "none",
                      backgroundColor:
                        !missingTestNames?.length && barCode?.includes("-")
                          ? "black"
                          : "white",
                      color:
                        !missingTestNames?.length && barCode?.includes("-")
                          ? "white"
                          : "black",
                      padding: ".0rem .2rem",
                      zIndex: 100,
                    }}
                  >
                    {missingTestNames?.length > 0 ? barCode?.replace(/-/g, "") : barCode}
                  </div>
                </span>
                {missingTestNames?.length > 0 && (
                  <div
                    style={{
                      fontSize: "0.6rem",
                      fontWeight: "bold",
                      color: "red",
                      border: "1.5px solid red",
                      padding: "1px 4px",
                      display: "inline-block",
                    }}
                  >
                    {missingTestNames.map((n) => (n === "LISS" ? "Liss" : n) + ": Missing").join(" , ")}
                  </div>
                )}
                {(isMissingBloodGroup || !isTestResult) &&
                  barCode !== "N/A" &&
                  !missingTestNames?.length && (
                  <div
                    style={{
                      fontSize: "0.6rem",
                      fontWeight: "bold",
                      color: "red",
                      border: "1.5px solid red",
                      padding: "1px 4px",
                      display: "inline-block",
                    }}
                  >
                    Blood Grp: Missing
                  </div>
                )}
              </div>
              {reason && (
                <span className="text-danger" style={{ zIndex: 900 }}>
                  {" "}
                  {`(${reason})`}
                </span>
              )}
            </div>
          )}
        </div>
        {description &&
          (title !== "Concetration" && title !== "Concentration" ? (
            <div>
              <span style={{ fontSize: 14, zIndex: 900 }} className="text-bold">
                {description
                  .replaceAll(":Positive", "")
                  .replaceAll(":Negative", "")
                  .replaceAll(":Du+", "")
                  .replaceAll(":d-", "")
                  .replaceAll(" - Notification status", "")
                  .replace(/\b([A-Z]) +-/g, "$1-")
                  .replace(/-\s+,/g, "-,")}
              </span>
            </div>
          ) : (
            <span style={{ fontSize: 16 }} className="text-bold">
              <span>{description}</span>

              {console.log("description and code", code, description, title)}
              {code === "12000" ? (
                <span style={{ fontSize: 14 }}>
                  ×10<sup>10</sup>
                </span>
              ) : (
                <span style={{ fontSize: 14 }}>
                  ×10<sup>11</sup>
                </span>
              )}
              <span
                style={{
                  fontSize: 12,
                  display: "inline-flex",
                  alignItems: "center",
                  marginLeft: "4px",
                }}
              ></span>
            </span>
          ))}
        {barCode && (
          <div style={{ zIndex: 900, backgroundColor: "white" }}>
            <Barcode
              displayValue={false}
              // value={barCode}
              value={`${barCode}`}
              width={1.5}
              height={16}
              options={{ width: 0.7 }}
            />
            {barCode && showValue && (
              <center>
                <h3>{barCode}</h3>
              </center>
            )}
          </div>
        )}
      </div>
    );
  };

  handleCheck(field) {
    this.setState({
      [field]: !this.state[field],
    });
  }

  handleUpdate = async () => {
    try {
      this.setState({ isUpdating: true });

      await this.updateProductInfo();

      this.getData(true);

      this.setState({ isUpdating: false });
      this.props.handleCloseModal?.();
    } catch (error) {
      this.setState({ isUpdating: false });

      toastMessage("error", error);
    }
  };

  updateProductInfo = async () => {
    const { data } = this.state;

    if (data.length === 0)
      return toastMessage(
        "error",
        language[this.props.defaultLanguage].no_data,
      );

    this.setState({
      isUpdating: true,
    });

// eslint-disable-next-line no-unused-vars
    const { donation, component, _id, center, centerSite, status } = data[0];
    const user = await getStorage();
// eslint-disable-next-line no-unused-vars

    let requestedBody = {
      id: _id,
      donation: donation._id,
      addedBy: user.id,
      component: component?._id,
      name: component.name,
      code: component.code,
      center: center?._id,
      centerSite: centerSite?._id,
      // status: "pending",
      bloodGroup: donation.bloodGroup,
    };

    const options = {
      method: "PUT",
      url: `${process.env.REACT_APP_BBMS_BASE_API}/inventory`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      },
      data: requestedBody,
    };

    await axios(options);
  };

  handleScan = async (value) => {
    try {
      // Check if a scan is already in progress
      if (this.state.isScanning) return;

      // Clear the input value immediately to prepare for new scans
      this.setState({ isScanning: true });

      // Validation checks
      if (!value) {
        this.setState({ isScanning: false });
        return toastMessage(
          "error",
          language[this.props.defaultLanguage].invalid_barcode,
        );
      }

      // Set scanned value and prepare key for further processing
      this.setState({ scannedValue: value });

      const { data } = this.state;

      if (data.length === 0) {
        this.setState({ isScanning: false });
        return toastMessage("error", "MISSING LABEL");
      }

      this.setState({ isVerifying: true });

      const user = await getStorage();

      const requestedBody = {
        value: typeof value === "string" ? value?.toUpperCase() : value,
        id: data[0]._id,
        verifiedBy: user.id,
      };

      const options = {
        method: "POST",
        url: `${API_URL}/inventory/verify-label`,
        data: requestedBody,
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      await axios(options);

      // Fetch data after scan
      await this.getData(false);
    } catch (error) {
      console.log(error);
      toastMessage("error", error);
    } finally {
      this.setState((prevState) => ({
        countScan: prevState.countScan + 1,
        scannedValue: "", // Clear scanned value
        value: "", // Clear input value for the next scan
      }));

      // Reset scanning state and refocus input

      this.setState((prevState) => ({
        countScan: prevState.countScan + 1,
        isScanning: false,
        isVerifying: false,
        scannedValue: "",
      }));
      this.scannerInputRef.current.focus(); // Refocus the input element
    }
  };

  renderLabelContent = () => {
    const isReactive = this.checkIsReactive();
    const isMissingBloodGroup = this.bloodGroupTrimTest();

    return (
      <div style={{ paddingRight: ".5rem" }}>
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={rbcLogo}
            style={{
              aspectRatio: 2 / 2,
              objectFit: "contain",
              width: "30%",
              opacity: 0.4,
              marginTop: "-10rem",
              marginRight: "4rem",
            }}
            alt=""
          />
        </div>
        <div style={{ zIndex: 100 }}>
          {this.state.data.map((el, i) => {
            return (
              <div
                key={i}
                style={{
                  minHeight: "106.8mm",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    paddingRight: "1.8rem",
                  }}
                >
                  <div style={{ flex: 1 }} />
                  <div>
                    <p>BTD RWANDA</p>
                    <p className="text-bold">
                      {el.center?.name}
                      {el.centerSite?.code ? ` (${el.centerSite?.code})` : ""}
                    </p>
                  </div>
                </div>
                <div className="card-body py-0">
                  {this.renderInfo({
                    title: el.name,
                    barCode: el.code,
                    type: "checkComponent",
                    displayValue: false,
                    showValue: true,
                  })}
                  {el.code === "12000" || el?.code?.includes("13000") ? (
                    this.renderInfo({
                      code: el.code,
                      title: "Concentration",
                      description: el.concentrationValue,
                    })
                  ) : (
                    <div></div>
                  )}
                  {this.renderInfo({
                    title: "Volume",
                    description: el.volume + " ML",
                  })}

                  {/* The bracket carries the patient ID, which is the
                      identifier staff quote, rather than the patient number
                      that used to sit there. */}
                  {el.patient &&
                    el.patient?._id &&
                    this.renderInfo({
                      title: "Patient",
                      description: `${
                        el.patient.firstName + " " + el.patient.lastName
                      } (${el.patient.patientId})`,
                    })}

                  {/* The ward this unit is going to. Taken from the unit's
                      shipment when available; falls back to the request's
                      hospitalization service before the shipment exists. */}
                  {(el?.shipmentService?.name ||
                    el?.request?.patientHospitalization?.service?.name) &&
                    this.renderInfo({
                      title: "Service",
                      description:
                        el.shipmentService?.name ||
                        el.request.patientHospitalization.service.name,
                    })}

                  {el.stock &&
                    el.isNominative &&
                    el.stock?._id &&
                    this.renderInfo({
                      title: "Hospital",
                      description: `${el.stock.name}(${el.stock.code})`,
                    })}

                  {el.patient &&
                    (el?.patient?.roomNumber ||
                      el?.request?.patientHospitalization?.roomNumber) &&
                    el.patient?._id &&
                    this.renderInfo({
                      title: "Room Number",
                      description:
                        el?.request?.patientHospitalization?.roomNumber ||
                        el?.patient?.roomNumber,
                    })}

                  {el.patient &&
                    el.patient?._id &&
                    (el?.patient?.bedNumber ||
                      el?.request?.patientHospitalization?.bedNumber) &&
                    this.renderInfo({
                      title: "Bed Number",
                      description:
                        el?.request?.patientHospitalization?.bedNumber ||
                        el?.patient?.bedNumber,
                    })}

                  {this.renderInfo({
                    title: "Phlebotomy Date",
                    description:
                      moment
                        .utc(el?.donation?.collectionDate)
                        .format("DD-MM-YYYY") +
                      " " +
                      el?.donation?.endTime,
                  })}
                  {this.renderInfo({
                    title: "Expiry Date",
                    description: el.expiredDate,
                  })}
                  {this.renderInfo({
                    title: "Non Remunerated Donation Number",
                    barCode: el.donation?.donationNumber,
                    isBlocked: !el?.donation?.isActive || isReactive,
                    // Which disease was reactive, not the bare word. The
                    // lab reads this line to know why the bag is blocked.
                    reason: isReactive
                      ? serologyGroups(el.serologyResult)
                          .filter((g) => !isCleanGroup(g))
                          .join(", ") || "Reactive"
                      : el?.donation?.blockInfo?.blockReason ||
                        el?.blockInfo?.blockReason ||
                        el?.rejectionInfo?.reason ||
                        el?.reasonId?.label ||
                        el?.reasonId?.value ||
                        el?.reason ||
                        el?.donation?.rejectionInfo?.reason ||
                        el?.donation?.reason ||
                        (!el?.donation?.isActive ? "Donation inactive" : ""),
                    type: "checkDonation",
                    displayValue: false,
                    showValue: true,
                  })}
                  {(() => {
                    const bgResult = el.bloodGroupingResult || "";
                    const bgEntries = bgResult.split(", ").map(entry => {
                      const colonIdx = entry.lastIndexOf(":");
                      if (colonIdx === -1) return null;
                      const questions = entry.slice(0, colonIdx).split(",").map(q => q.trim());
                      const answer = entry.slice(colonIdx + 1).trim();
                      return { questions, answer };
                    }).filter(Boolean);
                    let lissAnswer = null;
                    let iatAnswer = null;
                    for (const entry of bgEntries) {
                      for (const q of entry.questions) {
                        if (/liss/i.test(q)) {
                          if (lissAnswer === null || entry.answer?.toUpperCase() !== "MISSING") {
                            lissAnswer = entry.answer;
                          }
                        }
                        if (q === "d-" || /^du[+-]$/i.test(q) || /^iat$/i.test(q)) {
                          if (iatAnswer === null || entry.answer?.toUpperCase() !== "MISSING") {
                            iatAnswer = entry.answer;
                          }
                        }
                      }
                    }
                    const lissIsMissing = lissAnswer?.toUpperCase() === "MISSING";
                    const lissIsNegative = !lissIsMissing && /negat/i.test(lissAnswer || "");
                    const iatIsMissing = iatAnswer?.toUpperCase() === "MISSING";
                    // CC (Check Cells): Negative means IAT confirmation failed → treat as Missing
                    const ccEntry = bgEntries.find(e => e.questions.some(q => /^cc$/i.test(q)));
                    const ccIsNegative = !!ccEntry && /negat/i.test(ccEntry.answer || "");
                    const missing = [];
                    if (lissIsMissing) {
                      missing.push("LISS");
                    }
                    if ((iatIsMissing || ccIsNegative) && lissIsNegative) {
                      missing.push("IAT");
                    }
                    const hasMissing =
                      el.serologyResult?.toUpperCase()?.includes("MISSING") ||
                      bgResult.toUpperCase().includes("MISSING");
                    // K+ (Kell positive) and AS+ (positive antibody screening) block
                    // normal distribution — treat the same as reactive units.
                    const isKellPositive = bgEntries.some(e =>
                      e.questions.some(q => /^K\+$/i.test(q.trim()))
                    );
                    const isAbScreeningPositive = bgEntries.some(e =>
                      e.questions.some(q => /^AS\+$/i.test(q.trim()))
                    );
                    const isBlockingResult = isReactive || isKellPositive || isAbScreeningPositive;
                    const effectiveBloodGroup = el.bloodGroup || el.donation?.bloodGroup;
                    return this.renderInfo({
                      title: "Blood Group",
                      // Deliberately N/A on a blocked unit: a usable-looking
                      // group on a bag that must not be used invites it
                      // being used.
                      barCode:
                        !el?.donation?.isActive ||
                        el?.donation?.blockInfo?.blocked ||
                        isBlockingResult ||
                        hasMissing
                          ? "N/A"
                          : effectiveBloodGroup === "unspecified"
                            ? ""
                            : (effectiveBloodGroup || "").replace(/\s*Du\+\s*/gi, "").trim(),
                      type: "checkBloodGroup",
                      displayValue: false,
                      reason: isKellPositive
                        ? "K+ Positive"
                        : hasMissing
                          ? (bgResult.toUpperCase().includes("MISSING")
                              ? "Blood grouping: 2nd entry required"
                              : "Serology: 2nd entry required")
                          : !isBlockingResult
                            ? el?.donation?.blockInfo?.blockReason
                            : "",
                      isTestResult:
                        !!(
                          effectiveBloodGroup &&
                          effectiveBloodGroup !== "unspecified" &&
                          effectiveBloodGroup !== ""
                        ) || el.isTestResult,
                      isMissingBloodGroup:
                        el.automatedResultType ||
                        (effectiveBloodGroup &&
                          effectiveBloodGroup !== "unspecified" &&
                          effectiveBloodGroup !== "")
                          ? false
                          : isMissingBloodGroup,
                      noPrint: hasMissing,
                      missingTestNames: missing,
                      duResult:
                        iatAnswer && iatAnswer.toUpperCase() !== "MISSING"
                          ? iatAnswer
                          : null,
                    });
                  })()}
                  {this.renderInfo({
                    title: "Storage Temperature",
                    description: (el?.component?.storageTemperature?.name || "").replace(/</g, "≤") || undefined,
                  })}
                  {(() => {
                    const sr = (el.serologyResult || "").trim();
                    const missingBadgeText = /2nd entry/i.test(sr)
                      ? "Serology: Double entry missing"
                      : "Missing results for: HIV, HBsAg, HCV, Syphilis";
                    const missingBadge = (
                      <div className="d-flex align-items-center" style={{ marginLeft: ".5rem" }}>
                        <div
                          style={{
                            fontSize: "0.6rem",
                            fontWeight: "bold",
                            color: "red",
                            border: "1.5px solid red",
                            padding: "1px 4px",
                            display: "inline-block",
                          }}
                        >
                          {missingBadgeText}
                        </div>
                      </div>
                    );
                    if (!sr) return missingBadge;
                    if (/serology missing/i.test(sr)) return missingBadge;
                    const serParts = sr.split(",").map((s) => s.trim()).filter(Boolean);
                    if (serParts.length > 0 && serParts.every((s) => s.toLowerCase().includes("missing"))) {
                      return missingBadge;
                    }
                    // Only the clean results belong here. The reactive one
                    // is printed under (Blocked) beside the donation
                    // number, where the reason for the block is read -
                    // repeating it down here would bury it again.
                    const clean = serologyGroups(sr).filter(isCleanGroup);

                    if (!clean.length) return null;

                    return clean.map((group, i) => (
                      <div key={i}>
                        {this.renderInfo({ title: "", description: group })}
                      </div>
                    ));
                  })()}
                  {/* Printed on a blocked unit as well: the phenotype was
                      determined and the lab needs it on the bag. */}
                  {(() => {
                    const bgEntries2 = (el.bloodGroupingResult || "").split(", ").map(entry => {
                      const colonIdx = entry.lastIndexOf(":");
                      if (colonIdx === -1) return null;
                      const questions = entry.slice(0, colonIdx).split(",").map(q => q.trim().replace(/^liss\s*-$/i, "Liss-"));
                      const answer = entry.slice(colonIdx + 1).trim();
                      return { questions, answer };
                    }).filter(Boolean);
                    // Backend appends Qualys phenotype to the end of the full bloodGroupingResult
                    // string with " ," separator, so it always ends up in the last entry's answer.
                    // Detect by " ," in the answer — not by question abbreviation.
                    let qualysPhenotype = "";
                    for (const e of bgEntries2) {
                      const spIdx = e.answer.indexOf(" ,");
                      if (spIdx !== -1) {
                        qualysPhenotype = e.answer.slice(spIdx + 2).trim();
                        break;
                      }
                    }
                    // When Qualys phenotype contains D+, LISS and IAT tests are not required
                    // (Qualys already confirms Rh+). Du+ shown alongside Qualys D+ is misleading.
                    const hasLissAnywhere = bgEntries2.some(e => e.questions.some(q => /liss/i.test(q)));
                    const phenotypeHasDPlus = qualysPhenotype && /D\+/.test(qualysPhenotype);
                    // If any explicit (non-Qualys) IAT entry is Negative, d- is authoritative —
                    // suppress Du+ even when the Qualys row records a Positive answer.
                    const manualIatIsNegative = bgEntries2.some(e =>
                      e.answer.indexOf(" ,") === -1 &&
                      e.questions.some(q => q === "d-" || /^du[+-]$/i.test(q) || /^iat$/i.test(q)) &&
                      /negat/i.test(e.answer) &&
                      e.answer.toUpperCase() !== "MISSING"
                    );
                    // CC (Check Cells) Negative: IAT confirmation failed — suppress d- on label
                    const ccEntry2 = bgEntries2.find(e => e.questions.some(q => /^cc$/i.test(q)));
                    const ccConfirmedNegative = !!ccEntry2 && /negat/i.test(ccEntry2.answer || "");
                    const cleaned = bgEntries2
                      .filter(e => e.answer.toUpperCase() !== "MISSING" && !e.questions.some(q => /^cc$/i.test(q)))
                      .map(e => {
                        const spaceCommaIdx = e.answer.indexOf(" ,");
                        // isDu: classic IAT/Du question OR the entry that carries the Qualys phenotype
                        const isDu = spaceCommaIdx !== -1 || e.questions.some(q => q === "d-" || /^du[+-]$/i.test(q) || /^iat$/i.test(q));
                        if (isDu) {
                          // Answer may be "Negative ,D+C-E-c+e+" (QUALYS phenotype appended after " ,")
                          const iatPart = spaceCommaIdx !== -1 ? e.answer.slice(0, spaceCommaIdx).trim() : e.answer.trim();
                          const phenotypePart = spaceCommaIdx !== -1 ? e.answer.slice(spaceCommaIdx + 2).trim() : null;
                          const isPositive = /posit/i.test(iatPart) || /^du\+$/i.test(iatPart);
                          const iatQuestions = e.questions.filter(q => q === "d-" || /^du[+-]$/i.test(q) || /^iat$/i.test(q));
                          // Drop IAT abbreviations (handled separately) and any antigen already in the Qualys phenotype
                          let otherQuestions = e.questions.filter(q =>
                            q !== "d-" && !/^du[+-]$/i.test(q) && !/^iat$/i.test(q)
                            && (!qualysPhenotype || !qualysPhenotype.includes(q))
                          );
                          // Infer LISS negative only when IAT was genuinely performed for Rh- screening.
                          // Skip inference when Qualys phenotype confirms D+ (LISS/IAT not required then).
                          if (!hasLissAnywhere && !otherQuestions.some(q => /liss/i.test(q)) && !phenotypeHasDPlus) {
                            otherQuestions = ["Liss-", ...otherQuestions];
                          }
                          const parts = [];
                          if (otherQuestions.length > 0) parts.push(`${otherQuestions.join(",")}:${iatPart}`);
                          // Suppress Du+ when Qualys phenotype already confirms D+ (redundant/misleading).
                          // Also suppress Du+ when a manual IAT entry explicitly says Negative — d- is authoritative.
                          // Show Du+ only for genuine IAT on Rh- blood where phenotype has D-.
                          if (isPositive && !phenotypeHasDPlus && !manualIatIsNegative) parts.push("Du+");
                          // Suppress d- when CC (Check Cells) is Negative — IAT confirmation failed, shown as Missing instead.
                          else if (!isPositive && iatQuestions.length > 0 && !ccConfirmedNegative) parts.push("d-");
                          if (phenotypePart) parts.push(phenotypePart);
                          return parts.length > 0 ? parts.join(" ,") : null;
                        }
                        // For non-IAT entries: drop questions already in the Qualys phenotype
                        const filteredQuestions = qualysPhenotype
                          ? e.questions.filter(q => !qualysPhenotype.includes(q))
                          : e.questions;
                        if (filteredQuestions.length === 0) return null;
                        return `${filteredQuestions.join(",")}:${e.answer}`;
                      })
                      .filter(Boolean)
                      .join(", ")
                      .trim();
                    return cleaned
                      ? this.renderInfo({ title: "", description: cleaned })
                      : null;
                  })()}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  checkIsReactive() {
    const isReactive = this.state?.data?.some((el) => {
      // Split by colon to separate test name and result
      const results = el.serologyResult?.split(","); // Split by comma for multiple tests

      return results?.some((res) => {
// eslint-disable-next-line no-unused-vars
        const [test, result] = res.split(":").map((str) => str.trim()); // Split test and result, trim whitespace
        return (
// eslint-disable-next-line no-unused-vars
          result?.toUpperCase() === "REACTIVE" ||
          result?.toUpperCase() === "GRAY ZONE"
        );
      });
    });

    return isReactive;
  }

  bloodGroupTrimTest() {
    const test = this.state?.data?.map((el) => {
      return el.bloodGroupingResult;
    });

    // Guard: if bloodGroupingResult is missing/undefined, treat as missing
    if (!test || !test[0]) return true;

    // Backend sets plain sentences like "Blood grouping missing result" — catch them early
    if (test[0].toLowerCase().includes("missing") || test[0].toLowerCase().includes("pending")) return true;

    // Step 1: Split into key-value pairs
    const pairs = test[0].split(",").map((pair) => pair.trim());

    // Step 2: Convert to {key, value} objects
    const parsedData = pairs.map((pair) => {
      const [key, value] = pair.split(":");
      return { key, value };
    });

    console.log("parsedData", parsedData);

    // Step 3: Check if any value is "missing" (case-insensitive)
    const isTestMissing = parsedData.some(
      (item) =>
        item.value?.toLowerCase()?.includes("missing") ||
        item.value?.toLowerCase()?.includes("pending"),
    );

    console.log("isTestMissing", isTestMissing);

    return isTestMissing;
  }

  renderPrintComponent() {
    const isReactive = this.checkIsReactive();
    let blockMessage = false;

    if (this.state.data?.[0]?.blockInfo?.blocked) {
      blockMessage = this.state.data?.[0]?.blockInfo?.blockReason;
    } else if (this.state.data?.[0]?.reasonId?.shouldAppearError) {
      blockMessage = this.state.data?.[0]?.reason;
    } else {
      blockMessage = "";
    }
    return (
      <>
        {this.state.data?.length > 0 && this.state.data[0].isLabeled && (
          <>
            <center className="noPrint card-body">
              <div
                className="badge badge-success badge-lg"
                style={{
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  height: 20,
                  justifyContent: "center",
                }}
              >
                Labelled
              </div>
            </center>
          </>
        )}
        <div style={{ position: "relative", overflow: "hidden" }}>
          {this.renderLabelContent(isReactive)}
          {isReactive ? (
            <div className="reactive-to-test">
              {Array.from({ length: 10 }).map((_, index) => (
                <span key={index}>REACTIVE</span>
              ))}
            </div>
          ) : (
            blockMessage && (
              <div className="reactive-to-test">
                {Array.from({ length: 10 }).map((_, index) => (
                  <span key={index}>{blockMessage}</span>
                ))}
              </div>
            )
          )}
        </div>
      </>
    );
  }

  render() {
    if (this.state.isLoading) {
      return (
        <center>
          <Loading className="fullscreen" />
        </center>
      );
    }

    if (this.state.data.length === 0) {
      return <Empty title={language[this.props.defaultLanguage].no_data} />;
    }

    return (
      <div style={{ paddingTop: "1rem", position: "relative" }}>
        {this.state.isVerifying && (
          <div className="verifying-label">
            <Loading />
            <center style={{ marginLeft: ".5rem" }}>
              <span>Verifying...</span>
            </center>
          </div>
        )}
        {this.state.data.length > 0 &&
        this.state.data[0].status === "transformed" ? (
          <>{this.renderPrintComponent()}</>
        ) : (
          <PrintComponent
            buttonText={
              this.state.data?.length > 0 && this.state.data[0].isLabeled
                ? "Reprint Label"
                : "Print Label"
            }
          >
            {this.renderPrintComponent()}
          </PrintComponent>
        )}

        {this.state.data.map((el, i) => {
          return (
            <div key={i}>
              <div className="card-body">
                {[
                  {
                    name: language[this.props.defaultLanguage].check_component,
                    type: "checkComponent",
                  },
                  {
                    name: language[this.props.defaultLanguage].check_blood_group,
                    type: "checkBloodGroup",
                  },
                  {
                    name: language[this.props.defaultLanguage]
                      .check_donation_number,
                    type: "checkDonation",
                  },
                ].map((checkEl, i) => {
                  return (
                    <Checkbox
                      key={i}
                      label={checkEl.name}
                      // onCheck={() => this.handleCheck(checkEl.type)}
                      checked={el[checkEl.type]}
                    />
                  );
                })}
              </div>
              <div className="modal-footer">
                <Button
                  text={language[this.props.defaultLanguage].cancel}
                  onPress={this.props.handleCloseModal}
                  className="btn-default"
                />
                <Button
                  text={language[this.props.defaultLanguage].update}
                  isSubmitting={this.state.isUpdating}
                  onPress={this.handleUpdate.bind(this, el)}
                />
              </div>
            </div>
          );
        })}
        <input
          onChange={(e) => this.setState({ scannedValue: e.target.value })}
          autoFocus
          value={this.state.scannedValue} // Bind value to state
          // style={{ position: "absolute", left: "-9999px" }}
          ref={this.scannerInputRef}
          // onKeyPress={(e) => this.handleScan(e.target.value)}
          onKeyDown={(e) => {
            console.log("Key pressed", e.key);
            if (e.key === "Enter") {
              this.handleScan(e.target.value);
            }
          }} // Attach the ref here
          style={{ textTransform: "uppercase" }}
        />
        <BarcodeScannerInput
          onScan={(txt) => this.handleScan(txt)}
          // targetInputRef={this.scannerInputRef.current}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(PrintableLabel);
